import { useState, useEffect } from 'react'

export const fontFamilies = [
  {
    id: 'inter',
    name: 'Inter',
    description: 'Clean and neutral — the industry standard for modern UI',
    value: "'Inter', ui-sans-serif, system-ui, sans-serif",
    sampleText: 'The quick brown fox jumps over the lazy dog',
  },
  {
    id: 'plus-jakarta',
    name: 'Plus Jakarta Sans',
    description: 'Geometric and warm — great for productivity tools',
    value: "'Plus Jakarta Sans', ui-sans-serif, system-ui, sans-serif",
    sampleText: 'The quick brown fox jumps over the lazy dog',
  },
  {
    id: 'dm-sans',
    name: 'DM Sans',
    description: 'Slightly rounded — friendly but professional',
    value: "'DM Sans', ui-sans-serif, system-ui, sans-serif",
    sampleText: 'The quick brown fox jumps over the lazy dog',
  },
  {
    id: 'outfit',
    name: 'Outfit',
    description: 'Contemporary geometric — fresh and highly readable',
    value: "'Outfit', ui-sans-serif, system-ui, sans-serif",
    sampleText: 'The quick brown fox jumps over the lazy dog',
  },
  {
    id: 'nunito-sans',
    name: 'Nunito Sans',
    description: 'Rounded and approachable — softer, welcoming feel',
    value: "'Nunito Sans', ui-sans-serif, system-ui, sans-serif",
    sampleText: 'The quick brown fox jumps over the lazy dog',
  },
]

export const themes = [
  {
    id: 'default',
    name: 'Apple Blue',
    description: 'Classic visionOS blue',
    category: 'Classic',
    previewColors: ['#007AFF', '#F5F5F7', '#E5E5EA'],
    cssVars: {
      light: {
        '--background': '240 10% 96%',
        '--foreground': '0 0% 11%',
        '--primary': '211 100% 50%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '0 0% 96%',
        '--secondary-foreground': '0 0% 11%',
        '--muted': '240 5% 93%',
        '--muted-foreground': '240 5% 42%',
        '--accent': '240 5% 93%',
        '--accent-foreground': '0 0% 11%',
        '--destructive': '0 84% 60%',
        '--destructive-foreground': '0 0% 98%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '211 100% 50%',
      },
      dark: {
        '--background': '240 6% 10%',
        '--foreground': '0 0% 97%',
        '--primary': '211 100% 50%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '240 6% 15%',
        '--secondary-foreground': '0 0% 97%',
        '--muted': '240 6% 15%',
        '--muted-foreground': '240 5% 70%',
        '--accent': '240 6% 15%',
        '--accent-foreground': '0 0% 97%',
        '--destructive': '0 62% 30%',
        '--destructive-foreground': '0 0% 96%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '211 100% 50%',
      },
    },
  },
  {
    id: 'rose',
    name: 'Rose',
    description: 'Warm and romantic',
    category: 'Vibrant',
    previewColors: ['#FF2D55', '#FFF1F2', '#FECDD3'],
    cssVars: {
      light: {
        '--background': '350 100% 98%',
        '--foreground': '350 10% 10%',
        '--primary': '348 100% 59%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '350 100% 96%',
        '--secondary-foreground': '350 10% 10%',
        '--muted': '350 20% 96%',
        '--muted-foreground': '350 10% 40%',
        '--accent': '350 100% 96%',
        '--accent-foreground': '350 10% 10%',
        '--destructive': '0 84% 60%',
        '--destructive-foreground': '0 0% 98%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '348 100% 59%',
      },
      dark: {
        '--background': '350 20% 10%',
        '--foreground': '350 10% 98%',
        '--primary': '348 100% 59%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '350 20% 20%',
        '--secondary-foreground': '350 10% 98%',
        '--muted': '350 20% 20%',
        '--muted-foreground': '350 10% 70%',
        '--accent': '350 20% 20%',
        '--accent-foreground': '350 10% 98%',
        '--destructive': '0 62% 30%',
        '--destructive-foreground': '0 0% 96%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '348 100% 59%',
      },
    },
  },
  {
    id: 'orange',
    name: 'Orange',
    description: 'Energetic and warm',
    category: 'Vibrant',
    previewColors: ['#FF9500', '#FFF7ED', '#FED7AA'],
    cssVars: {
      light: {
        '--background': '30 100% 98%',
        '--foreground': '30 10% 10%',
        '--primary': '35 100% 50%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '30 100% 96%',
        '--secondary-foreground': '30 10% 10%',
        '--muted': '30 20% 96%',
        '--muted-foreground': '30 10% 40%',
        '--accent': '30 100% 96%',
        '--accent-foreground': '30 10% 10%',
        '--destructive': '0 84% 60%',
        '--destructive-foreground': '0 0% 98%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '35 100% 50%',
      },
      dark: {
        '--background': '30 20% 10%',
        '--foreground': '30 10% 98%',
        '--primary': '35 100% 50%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '30 20% 20%',
        '--secondary-foreground': '30 10% 98%',
        '--muted': '30 20% 20%',
        '--muted-foreground': '30 10% 70%',
        '--accent': '30 20% 20%',
        '--accent-foreground': '30 10% 98%',
        '--destructive': '0 62% 30%',
        '--destructive-foreground': '0 0% 96%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '35 100% 50%',
      },
    },
  },
  {
    id: 'emerald',
    name: 'Emerald',
    description: 'Fresh and natural',
    category: 'Vibrant',
    previewColors: ['#34C759', '#ECFDF5', '#A7F3D0'],
    cssVars: {
      light: {
        '--background': '150 100% 98%',
        '--foreground': '150 10% 10%',
        '--primary': '142 76% 36%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '150 100% 96%',
        '--secondary-foreground': '150 10% 10%',
        '--muted': '150 20% 96%',
        '--muted-foreground': '150 10% 40%',
        '--accent': '150 100% 96%',
        '--accent-foreground': '150 10% 10%',
        '--destructive': '0 84% 60%',
        '--destructive-foreground': '0 0% 98%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '142 76% 36%',
      },
      dark: {
        '--background': '150 20% 10%',
        '--foreground': '150 10% 98%',
        '--primary': '142 70% 50%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '150 20% 20%',
        '--secondary-foreground': '150 10% 98%',
        '--muted': '150 20% 20%',
        '--muted-foreground': '150 10% 70%',
        '--accent': '150 20% 20%',
        '--accent-foreground': '150 10% 98%',
        '--destructive': '0 62% 30%',
        '--destructive-foreground': '0 0% 96%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '142 70% 50%',
      },
    },
  },
  {
    id: 'violet',
    name: 'Violet',
    description: 'Creative and bold',
    category: 'Vibrant',
    previewColors: ['#AF52DE', '#F5F3FF', '#DDD6FE'],
    cssVars: {
      light: {
        '--background': '270 100% 98%',
        '--foreground': '270 10% 10%',
        '--primary': '280 67% 55%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '270 100% 96%',
        '--secondary-foreground': '270 10% 10%',
        '--muted': '270 20% 96%',
        '--muted-foreground': '270 10% 40%',
        '--accent': '270 100% 96%',
        '--accent-foreground': '270 10% 10%',
        '--destructive': '0 84% 60%',
        '--destructive-foreground': '0 0% 98%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '280 67% 55%',
      },
      dark: {
        '--background': '270 20% 10%',
        '--foreground': '270 10% 98%',
        '--primary': '280 67% 55%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '270 20% 20%',
        '--secondary-foreground': '270 10% 98%',
        '--muted': '270 20% 20%',
        '--muted-foreground': '270 10% 70%',
        '--accent': '270 20% 20%',
        '--accent-foreground': '270 10% 98%',
        '--destructive': '0 62% 30%',
        '--destructive-foreground': '0 0% 96%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '280 67% 55%',
      },
    },
  },
  {
    id: 'cyan',
    name: 'Cyan',
    description: 'Cool and modern',
    category: 'Vibrant',
    previewColors: ['#32ADE6', '#ECFEFF', '#A5F3FC'],
    cssVars: {
      light: {
        '--background': '190 100% 98%',
        '--foreground': '190 10% 10%',
        '--primary': '195 77% 55%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '190 100% 96%',
        '--secondary-foreground': '190 10% 10%',
        '--muted': '190 20% 96%',
        '--muted-foreground': '190 10% 40%',
        '--accent': '190 100% 96%',
        '--accent-foreground': '190 10% 10%',
        '--destructive': '0 84% 60%',
        '--destructive-foreground': '0 0% 98%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '195 77% 55%',
      },
      dark: {
        '--background': '190 20% 10%',
        '--foreground': '190 10% 98%',
        '--primary': '195 77% 55%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '190 20% 20%',
        '--secondary-foreground': '190 10% 98%',
        '--muted': '190 20% 20%',
        '--muted-foreground': '190 10% 70%',
        '--accent': '190 20% 20%',
        '--accent-foreground': '190 10% 98%',
        '--destructive': '0 62% 30%',
        '--destructive-foreground': '0 0% 96%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '195 77% 55%',
      },
    },
  },
  {
    id: 'slate',
    name: 'Slate',
    description: 'Professional and neutral',
    category: 'Cool Tones',
    previewColors: ['#8E8E93', '#F8FAFC', '#E2E8F0'],
    cssVars: {
      light: {
        '--background': '210 20% 98%',
        '--foreground': '210 10% 10%',
        '--primary': '210 10% 40%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '210 10% 96%',
        '--secondary-foreground': '210 10% 10%',
        '--muted': '210 10% 96%',
        '--muted-foreground': '210 5% 40%',
        '--accent': '210 10% 96%',
        '--accent-foreground': '210 10% 10%',
        '--destructive': '0 84% 60%',
        '--destructive-foreground': '0 0% 98%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '210 10% 40%',
      },
      dark: {
        '--background': '210 10% 10%',
        '--foreground': '210 10% 98%',
        '--primary': '210 10% 60%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '210 10% 20%',
        '--secondary-foreground': '210 10% 98%',
        '--muted': '210 10% 20%',
        '--muted-foreground': '210 5% 70%',
        '--accent': '210 10% 20%',
        '--accent-foreground': '210 10% 98%',
        '--destructive': '0 62% 30%',
        '--destructive-foreground': '0 0% 96%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '210 10% 60%',
      },
    },
  },
  {
    id: 'indigo',
    name: 'Indigo',
    description: 'Deep and sophisticated',
    category: 'Cool Tones',
    previewColors: ['#5856D6', '#EEF2FF', '#C7D2FE'],
    cssVars: {
      light: {
        '--background': '240 100% 98%',
        '--foreground': '240 10% 10%',
        '--primary': '245 58% 51%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '240 100% 96%',
        '--secondary-foreground': '240 10% 10%',
        '--muted': '240 20% 96%',
        '--muted-foreground': '240 10% 40%',
        '--accent': '240 100% 96%',
        '--accent-foreground': '240 10% 10%',
        '--destructive': '0 84% 60%',
        '--destructive-foreground': '0 0% 98%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '245 58% 51%',
      },
      dark: {
        '--background': '240 20% 10%',
        '--foreground': '240 10% 98%',
        '--primary': '245 58% 51%',
        '--primary-foreground': '0 0% 100%',
        '--secondary': '240 20% 20%',
        '--secondary-foreground': '240 10% 98%',
        '--muted': '240 20% 20%',
        '--muted-foreground': '240 10% 70%',
        '--accent': '240 20% 20%',
        '--accent-foreground': '240 10% 98%',
        '--destructive': '0 62% 30%',
        '--destructive-foreground': '0 0% 96%',
        '--border': '0 0% 100%',
        '--input': '0 0% 100%',
        '--ring': '245 58% 51%',
      },
    },
  },
]

export const getCategories = () => {
  const categoryMap = new Map()
  themes.forEach((theme) => {
    categoryMap.set(theme.category, (categoryMap.get(theme.category) || 0) + 1)
  })
  return Array.from(categoryMap.entries()).map(([name, count]) => ({
    name,
    count,
  }))
}

export const getThemesByCategory = (category) => {
  return themes.filter((theme) => theme.category === category)
}

const THEME_STORAGE_KEY = 'focus-pane-theme'
const MODE_STORAGE_KEY = 'focus-pane-mode'
const FONT_STORAGE_KEY = 'focus-pane-font'

// Migrate old localStorage keys on first load
if (typeof window !== 'undefined') {
  const oldThemeKey = localStorage.getItem('theme')
  const oldColorTheme = localStorage.getItem('colorTheme')

  if (oldThemeKey && !localStorage.getItem(MODE_STORAGE_KEY)) {
    localStorage.setItem(MODE_STORAGE_KEY, oldThemeKey)
    localStorage.removeItem('theme')
  }
  if (oldColorTheme && !localStorage.getItem(THEME_STORAGE_KEY)) {
    const mapped = themes.find((t) => t.id === oldColorTheme)
    if (mapped) {
      localStorage.setItem(THEME_STORAGE_KEY, mapped.id)
    }
    localStorage.removeItem('colorTheme')
  }
}

// Immediately apply theme on module load to prevent flash
if (typeof window !== 'undefined') {
  const savedMode = localStorage.getItem(MODE_STORAGE_KEY)
  if (savedMode === 'dark') {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }

  const savedThemeId = localStorage.getItem(THEME_STORAGE_KEY)
  const isDark = savedMode === 'dark'
  const savedTheme = themes.find((t) => t.id === (savedThemeId || 'orange'))
  if (savedTheme) {
    const vars = isDark ? savedTheme.cssVars.dark : savedTheme.cssVars.light
    const root = document.documentElement
    Object.entries(vars).forEach(([key, value]) => {
      root.style.setProperty(key, value)
    })
  }

  const savedFontId = localStorage.getItem(FONT_STORAGE_KEY)
  const savedFont = fontFamilies.find((f) => f.id === (savedFontId || 'inter'))
  if (savedFont) {
    document.documentElement.style.setProperty('--font-family', savedFont.value)
    document.body.style.fontFamily = savedFont.value
  }
}

export function useTheme() {
  const [currentTheme, setCurrentTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(THEME_STORAGE_KEY)
      if (saved) {
        const found = themes.find((t) => t.id === saved)
        if (found) return found
      }
    }
    return themes.find((t) => t.id === 'orange') || themes[0]
  })

  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(MODE_STORAGE_KEY)
      if (saved !== null) {
        const dark = saved === 'dark'
        if (dark) {
          document.documentElement.classList.add('dark')
        } else {
          document.documentElement.classList.remove('dark')
        }
        return dark
      }
      document.documentElement.classList.remove('dark')
    }
    return false
  })

  const [currentFont, setCurrentFont] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(FONT_STORAGE_KEY)
      if (saved) {
        const found = fontFamilies.find((f) => f.id === saved)
        if (found) return found
      }
    }
    return fontFamilies[0]
  })

  const applyFont = (font) => {
    document.documentElement.style.setProperty('--font-family', font.value)
    document.body.style.fontFamily = font.value
  }

  const applyTheme = (theme, dark) => {
    const root = document.documentElement
    const vars = dark ? theme.cssVars.dark : theme.cssVars.light
    Object.entries(vars).forEach(([key, value]) => {
      root.style.setProperty(key, value)
    })
  }

  const applyDarkMode = (dark) => {
    const root = document.documentElement
    if (dark) {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }

  useEffect(() => {
    applyTheme(currentTheme, isDarkMode)
    applyDarkMode(isDarkMode)
    applyFont(currentFont)
  }, [])

  const setTheme = (theme) => {
    setCurrentTheme(theme)
    applyTheme(theme, isDarkMode)
    localStorage.setItem(THEME_STORAGE_KEY, theme.id)
  }

  const toggleDarkMode = () => {
    const newMode = !isDarkMode
    setIsDarkMode(newMode)
    applyDarkMode(newMode)
    applyTheme(currentTheme, newMode)
    localStorage.setItem(MODE_STORAGE_KEY, newMode ? 'dark' : 'light')
  }

  const setMode = (dark) => {
    setIsDarkMode(dark)
    applyDarkMode(dark)
    applyTheme(currentTheme, dark)
    localStorage.setItem(MODE_STORAGE_KEY, dark ? 'dark' : 'light')
  }

  const setFont = (font) => {
    setCurrentFont(font)
    applyFont(font)
    localStorage.setItem(FONT_STORAGE_KEY, font.id)
  }

  const previewFont = (font) => {
    applyFont(font)
  }

  const resetFontPreview = () => {
    applyFont(currentFont)
  }

  const previewTheme = (theme) => {
    applyTheme(theme, isDarkMode)
  }

  const resetPreview = () => {
    applyTheme(currentTheme, isDarkMode)
  }

  return {
    currentTheme,
    isDarkMode,
    currentFont,
    themes,
    fontFamilies,
    categories: getCategories(),
    getThemesByCategory,
    setTheme,
    toggleDarkMode,
    setMode,
    setFont,
    previewFont,
    resetFontPreview,
    previewTheme,
    resetPreview,
  }
}
